/* @ngInject */
function UsedInController ($scope, $rootScope, $state, $translate, $stateParams, $timeout, $location, RepositoryService) {
  $scope.$parent.selectedMenuId = $state.current.data.selectedMenuId
  $scope.currentPage = 'used-in'
  $scope.currentSubPage = $stateParams.usedInModule
  $scope.emptyState = {
    imgPath: 'empty-state-' + $scope.currentPage,
    title: $translate.instant('repository.emptyState.usedIn.title'),
    message: $translate.instant('repository.emptyState.usedIn.message.' + $scope.currentSubPage)
  }
  $scope.hasShowMoreButton = false
  $scope.pagination = {
    $sort: 'latestUpdates',
    $order: 'DESC',
    $top: 30,
    $skip: 0
  }

  $scope.filters = {
    type: null,
    extension: null
  }
  $scope.sections = [
    { slug: $scope.currentSubPage, assets: [], totalCount: 0 }
  ]

  let title = ''

  const api = {
    _loadAssets,
    _hasMoreResults,
    _resetAllSections,
    _setHeader,
    _searchAssets,
    _clearSearch,
    _successLoadAssets
  }

  this.getApi = () => api

  function activate () {
    $scope.initialLoad = true

    const view = RepositoryService.getView()
    if (view) {
      $location.search({ view })
    } else if ($stateParams.view) {
      $location.search({ view: $stateParams.view })
      RepositoryService.setView($stateParams.view)
    }

    $timeout(() => {
      api._loadAssets().then(() => {
        $scope.initialLoad = false
      })
    }, 500)
  }

  activate()

  $scope.loadAssets = api._loadAssets

  const deregisterSelectAssetsSortOrder = $rootScope.$on('select-assets-sort-order', (e, file) => {
    $scope.pagination.$sort = file.sort
    $scope.pagination.$order = file.order
    api._resetAllSections()
    api._loadAssets()
  })

  $scope.$on('$destroy', () => {
    deregisterSelectAssetsSortOrder()
  })

  function _resetAllSections () {
    $scope.$broadcast('repository.load-assets-start')
    $scope.hasShowMoreButton = false
    $scope.pagination.$skip = 0
    $scope.sections[0].assets = []
  }

  $translate.onReady(() => {
    const modules = {
      arts: 'repository.sidebarSections.materials',
      workflow: 'repository.sidebarSections.workflow',
      posts: 'repository.sidebarSections.posts',
      checklist: 'repository.sidebarSections.checklist',
      brand: 'repository.sidebarSections.brand'
    }

    title = $translate.instant(modules[$scope.currentSubPage])
    api._setHeader()
  })

  $scope.$watchCollection('headerToolbar.repositoryFilter.params', (fileTypes) => {
    if ($scope.initialLoad) {
      return
    }

    let fileType = null

    for (const type in fileTypes) {
      if (fileTypes[type]) {
        fileType = type
        break
      }
    }

    $scope.filters.type = fileType
    $scope.filters.extension = null

    api._resetAllSections()
    api._loadAssets()
  })

  const deregisterExtensionFilterUpdate = $scope.$on('repository-filters.extension-filter-update', (e, extension) => {
    $scope.filters.extension = extension

    api._resetAllSections()
    api._loadAssets()
  })

  $scope.$on('$destroy', () => {
    deregisterExtensionFilterUpdate()
  })

  $scope.$watch('assetSearch', function () {
    if ($scope.initialLoad) {
      return
    }

    $scope.pagination.$skip = 0
    $scope.sections[0].assets = []

    api._resetAllSections()
    api._loadAssets()
  })

  function _loadAssets () {
    return RepositoryService.getUsedInAssets({
      usedIn: $scope.currentSubPage,
      $sort: $scope.pagination.$sort,
      $order: $scope.pagination.$order,
      $top: $scope.pagination.$top,
      $skip: $scope.pagination.$skip,
      search: $scope.assetSearch,
      filters: $scope.filters
    }).then(api._successLoadAssets)
  }

  function _hasMoreResults (totalCount, responseLength) {
    if (!responseLength) {
      return false
    }

    return Number(totalCount) > responseLength
  }

  function _setHeader () {
    const headerInfo = RepositoryService.getHeader($scope.searching, title, { searchAssets: api._searchAssets, clearSearch: api._clearSearch })

    if ($scope.filters.type) {
      headerInfo.headerToolbar.repositoryFilter.params.all = false
      headerInfo.headerToolbar.repositoryFilter.params[$scope.filters.type] = true
    }

    $scope.headerToolbar = headerInfo.headerToolbar
    $scope.headerNavigation = headerInfo.headerNavigation
    $scope.headerTitle = headerInfo.headerTitle
  }

  function _searchAssets (term) {
    if (!term) {
      api._clearSearch()
      return
    }

    $scope.sections.forEach(section => {
      section.searchedAssets = []
      section.searchedCount = null
    })

    $scope.searching = !!term
    $scope.assetSearch = term
    api._setHeader()
  }

  function _clearSearch () {
    $scope.searching = false
    api._setHeader()
    $('.header .deskfy-header uds-input-search').attr('value', null)

    $scope.assetSearch = ''
  }

  function _successLoadAssets (assets) {
    $scope.pagination.$skip = $scope.pagination.$skip += $scope.pagination.$top
    $scope.sections[0].assets = $scope.sections[0].assets.concat(assets.rows)
    $scope.sections[0].totalCount = assets.count
    $scope.hasShowMoreButton = api._hasMoreResults(assets.count, $scope.sections[0].assets.length)
    $scope.$broadcast('repository.load-assets-end')
  }
}

export { UsedInController }
